import golfMobileMaskSrc from '../assets/sport-icons/golf_icon.svg?no-inline'
import tennisMobileMaskSrc from '../assets/sport-icons/tennis_icon.svg?no-inline'
import padelMobileMaskSrc from '../assets/sport-icons/padel_icon.svg?no-inline'
import squashMobileMaskSrc from '../assets/sport-icons/squash_icon.svg?no-inline'
import pickleballMobileMaskSrc from '../assets/sport-icons/pickleball_icon.svg?no-inline'

const SPORT_LEVEL_ICON_BASE_URL = 'https://privana-icons.s3.eu-north-1.amazonaws.com'
// The desktop Members Portal and the mobile bundle intentionally share this
// stable asset revision. The S3 keys have previously been updated in place, so
// the revision prevents a WKWebView from retaining an older object forever.
export const SPORT_LEVEL_ICON_VERSION = '20260729'

const sportIconUrl = (objectKey) => `${SPORT_LEVEL_ICON_BASE_URL}/${objectKey}?v=${SPORT_LEVEL_ICON_VERSION}`

const sportLevelIconByKey = {
  golf: sportIconUrl('golf_icon.svg'),
  tennis: sportIconUrl('tennis_icon.svg'),
  padel: sportIconUrl('padel_icon.svg'),
  squash: sportIconUrl('squash_icon.svg'),
  pickleball: sportIconUrl('pickleball_icon.svg'),
}

export { sportLevelIconByKey }

export const sportLevelMobileMaskByKey = {
  golf: golfMobileMaskSrc,
  tennis: tennisMobileMaskSrc,
  padel: padelMobileMaskSrc,
  squash: squashMobileMaskSrc,
  pickleball: pickleballMobileMaskSrc,
}

export const sportLevels = [
  {
    key: 'golf',
    name: 'Golf',
    iconSrc: sportLevelIconByKey.golf,
    mobileMaskSrc: sportLevelMobileMaskByKey.golf,
    min: -36,
    max: 5,
    step: 0.1,
    formatValue: (value) => `${value > 0 ? '+' : ''}${value}`,
    detail: 'Higher is better · +5 to -36',
  },
  {
    key: 'tennis',
    name: 'Tennis',
    iconSrc: sportLevelIconByKey.tennis,
    mobileMaskSrc: sportLevelMobileMaskByKey.tennis,
    min: 1,
    max: 5,
    step: 0.1,
    detail: 'Match-ready intensity',
  },
  {
    key: 'padel',
    name: 'Padel',
    iconSrc: sportLevelIconByKey.padel,
    mobileMaskSrc: sportLevelMobileMaskByKey.padel,
    min: 1,
    max: 5,
    step: 0.1,
    detail: 'Clubhouse energy',
  },
  {
    key: 'squash',
    name: 'Squash',
    iconSrc: sportLevelIconByKey.squash,
    mobileMaskSrc: sportLevelMobileMaskByKey.squash,
    min: 1,
    max: 5,
    step: 0.1,
    detail: 'Court sharpness',
  },
  {
    key: 'pickleball',
    name: 'Pickleball',
    iconSrc: sportLevelIconByKey.pickleball,
    mobileMaskSrc: sportLevelMobileMaskByKey.pickleball,
    min: 1,
    max: 5,
    step: 0.1,
    detail: 'Social to elite',
  },
]
